/*
 * @Author: 任晓帅
 * @Contact: VX:ren18321147631
 * @Date: 2026-02-15 08:40:39
 * @Description: 不可进行二次销售
 */
import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import errorCode from './errorCode'

// 创建axios实例
const service = axios.create({
  baseURL: '/', // API基础URL
  timeout: 15000, // 请求超时时间
  withCredentials: true // 跨域请求时是否需要凭证
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 添加token到请求头
    if (store.getters.token) {
      config.headers['token'] =getToken()
    }
    return config
  },
  error => {
    console.log('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    
    const res = response.data
    var token=null;
    if(response.headers['token']) {
      token = response.headers['token']
    }
    // 根据自定义状态码处理
    if (res.code !== 200) {
      // 401: 未登录或token过期
      if (res.code === 401) {
        MessageBox.confirm('登录状态已过期，请重新登录', '系统提示', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/logoutFront').then(() => {
            location.reload()
          })
        })
      } else {
        Message({
          message: res.msg || errorCode[res.code] || '未知错误',
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      res.data.token = token
      return res.data
    }
  },
  error => {
    console.log('响应错误:', error)
    let message = error.message
    
    if (error.response) {
      switch (error.response.status) {
        case 401:
          message = '未授权，请重新登录'
          break
        case 403:
          message = '拒绝访问'
          break
        case 404:
          message = '请求地址不存在'
          break
        case 408:
          message = '请求超时'
          break
        case 500:
          message = '服务器内部错误'
          break
        default:
          message = `连接错误${error.response.status}`
      }
    }
    
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    
    return Promise.reject(error)
  }
)

export default service